module.exports = __webpack_public_path__ + "media/src/images/app_icons/ios_splashscreens/ipad_splash-7c4de72872d98a401c31f729781f1b6d.png";